// YouTube (share drawers + helpers) i18n fragment — part 2
// Namespaces: yt.autoShareRule, yt.scheduleShare, yt.shareToFacebook, yt.shareToX,
// yt.uploadVideo, yt.facebookTargetPicker, yt.shareHelpers, yt.xShareHelpers.
// vi = original Vietnamese (verbatim), en = natural concise English. Keys in parity.
const fragment = {
  vi: {
    // ===== shareHelpers — caption presets =====
    'yt.shareHelpers.preset.default': 'Mặc định (title + link)',
    'yt.shareHelpers.preset.hashtag': 'Có hashtag YouTube',
    'yt.shareHelpers.preset.oneLine': 'Ngắn gọn 1 dòng',
    'yt.shareHelpers.preset.emoji': 'Emoji nổi bật',
    'yt.shareHelpers.preset.cta': 'Call to action',

    // ===== xShareHelpers — caption presets + reset countdown =====
    'yt.xShareHelpers.preset.default': 'Mặc định (title + link)',
    'yt.xShareHelpers.preset.hashtag': 'Hashtag YouTube + Video',
    'yt.xShareHelpers.preset.watchNow': 'Watch now (EN)',
    'yt.xShareHelpers.preset.watchVn': 'Xem ngay (VN)',
    'yt.xShareHelpers.preset.cta': 'CTA ngắn',
    'yt.xShareHelpers.reset.resetting': 'đang reset',
    'yt.xShareHelpers.reset.inMinutes': 'trong {value} phút',
    'yt.xShareHelpers.reset.inHours': 'trong {value} giờ',
    'yt.xShareHelpers.reset.atTime': 'lúc {value}',

    // ===== FacebookTargetPicker =====
    'yt.facebookTargetPicker.accountLabel': 'Tài khoản Facebook',
    'yt.facebookTargetPicker.noAccountPre': 'Chưa có tài khoản Facebook. Vào',
    'yt.facebookTargetPicker.noAccountPost': 'để liên kết.',
    'yt.facebookTargetPicker.selectAccountOption': '-- Chọn tài khoản --',
    'yt.facebookTargetPicker.pagesLabel': 'Page nhận chia sẻ',
    'yt.facebookTargetPicker.reload': 'Tải lại',
    'yt.facebookTargetPicker.searchPlaceholder': 'Tìm theo tên page...',
    'yt.facebookTargetPicker.loadPagesFailed': 'Không tải được pages.',
    'yt.facebookTargetPicker.noPages': 'Tài khoản này chưa quản lý page nào.',
    'yt.facebookTargetPicker.noMatch': 'Không tìm thấy page khớp "{query}".',
    'yt.facebookTargetPicker.deselect': 'Bỏ chọn',
    'yt.facebookTargetPicker.selectVisible': 'Chọn {count} page hiển thị',
    'yt.facebookTargetPicker.selectAll': 'Chọn tất cả {count} page',

    // ===== AutoShareRuleDrawer =====
    'yt.autoShareRule.delay.now': 'Ngay',
    'yt.autoShareRule.delay.15m': '15 phút',
    'yt.autoShareRule.delay.30m': '30 phút',
    'yt.autoShareRule.delay.1h': '1 giờ',
    'yt.autoShareRule.relative.never': 'chưa quét lần nào',
    'yt.autoShareRule.relative.justNow': 'vừa xong',
    'yt.autoShareRule.relative.minutesAgo': '{value} phút trước',
    'yt.autoShareRule.relative.hoursAgo': '{value} giờ trước',
    'yt.autoShareRule.relative.daysAgo': '{value} ngày trước',
    'yt.autoShareRule.sampleVideoTitle': 'Video demo kênh',
    'yt.autoShareRule.title': 'Tự động chia sẻ video mới',
    'yt.autoShareRule.intro.pre': 'Hệ thống quét kênh mỗi ~20 phút. Khi phát hiện',
    'yt.autoShareRule.intro.bold': 'video public mới',
    'yt.autoShareRule.intro.post':
      ', nó tạo lịch chia sẻ lên Facebook (sau khoảng trễ bạn đặt — bạn vẫn kịp hủy ở trang "Lịch đã đặt"). Video đăng dạng private/unlisted sẽ không được tự chia sẻ.',
    'yt.autoShareRule.section1': 'Quy tắc đang áp dụng ({count})',
    'yt.autoShareRule.empty': 'Chưa có quy tắc nào. Tạo một quy tắc ở mục bên dưới.',
    'yt.autoShareRule.badge.running': 'Đang chạy',
    'yt.autoShareRule.badge.paused': 'Tạm dừng',
    'yt.autoShareRule.pageCount': '{count} page',
    'yt.autoShareRule.ruleStats':
      'Trễ {delay}p · phát hiện {detected} · lên lịch {scheduled} · quét {scanned}',
    'yt.autoShareRule.tooltip.pause': 'Tạm dừng',
    'yt.autoShareRule.tooltip.resume': 'Bật lại',
    'yt.autoShareRule.tooltip.scanNow': 'Quét ngay',
    'yt.autoShareRule.tooltip.edit': 'Sửa',
    'yt.autoShareRule.tooltip.delete': 'Xóa',
    'yt.autoShareRule.section2.edit': 'Sửa quy tắc',
    'yt.autoShareRule.section2.create': 'Tạo quy tắc mới',
    'yt.autoShareRule.cancelEdit': 'Hủy sửa',
    'yt.autoShareRule.captionLabel': 'Caption (token {{title}} · {{link}})',
    'yt.autoShareRule.pickTemplate': 'Chọn mẫu...',
    'yt.autoShareRule.reset': 'Đặt lại',
    'yt.autoShareRule.optimalChars': 'Tối ưu ≤ {limit} ký tự',
    'yt.autoShareRule.charCount': '{count} ký tự',
    'yt.autoShareRule.preview': 'Xem trước',
    'yt.autoShareRule.previewEmpty': '(rỗng)',
    'yt.autoShareRule.delayLabel': 'Trễ trước khi đăng (phút sau khi phát hiện video)',
    'yt.autoShareRule.delayNote.pre': 'Chỉ video đăng',
    'yt.autoShareRule.delayNote.bold': 'từ bây giờ trở đi',
    'yt.autoShareRule.delayNote.post':
      ' mới được tự chia sẻ — video cũ trên kênh không bị ảnh hưởng.',
    'yt.autoShareRule.close': 'Đóng',
    'yt.autoShareRule.saveChanges': 'Lưu thay đổi',
    'yt.autoShareRule.createRule': 'Tạo quy tắc',
    'yt.autoShareRule.confirm.deleteTitle': 'Xóa quy tắc?',
    'yt.autoShareRule.confirm.deleteDesc':
      'Sẽ ngừng tự động chia sẻ video mới tới {count} page. Các lịch đã tạo trước đó không bị ảnh hưởng.',
    'yt.autoShareRule.confirm.deleteConfirm': 'Xóa',
    'yt.autoShareRule.toast.toggleFailed': 'Đổi trạng thái thất bại.',
    'yt.autoShareRule.toast.scanError': 'Quét lỗi: {error}',
    'yt.autoShareRule.toast.scanDone':
      'Quét xong: phát hiện {detected} video mới, lên lịch {scheduled} bài.',
    'yt.autoShareRule.toast.scanNoNew': 'Quét xong: không có video mới.',
    'yt.autoShareRule.toast.scanFailed': 'Quét thất bại.',
    'yt.autoShareRule.toast.deleted': 'Đã xóa quy tắc.',
    'yt.autoShareRule.toast.deleteFailed': 'Xóa thất bại.',
    'yt.autoShareRule.toast.pickAccount': 'Vui lòng chọn tài khoản Facebook.',
    'yt.autoShareRule.toast.pickPage': 'Chọn ít nhất 1 page.',
    'yt.autoShareRule.toast.updated': 'Đã cập nhật quy tắc.',
    'yt.autoShareRule.toast.updateFailed': 'Cập nhật thất bại.',
    'yt.autoShareRule.toast.created': 'Đã tạo quy tắc. Video mới đăng từ giờ sẽ tự được chia sẻ.',
    'yt.autoShareRule.toast.createFailed': 'Tạo quy tắc thất bại.',

    // ===== ScheduleShareDrawer =====
    'yt.scheduleShare.window.6h': '6 giờ',
    'yt.scheduleShare.window.12h': '12 giờ',
    'yt.scheduleShare.window.1d': '1 ngày',
    'yt.scheduleShare.window.3d': '3 ngày',
    'yt.scheduleShare.window.1w': '1 tuần',
    'yt.scheduleShare.title': 'Lên lịch chia sẻ {count} video lên Facebook',
    'yt.scheduleShare.section1': 'Đích chia sẻ',
    'yt.scheduleShare.accountLabel': 'Tài khoản Facebook',
    'yt.scheduleShare.noAccountPre': 'Chưa có tài khoản Facebook. Vào',
    'yt.scheduleShare.noAccountPost': 'để liên kết.',
    'yt.scheduleShare.pagesLabel': 'Page nhận chia sẻ',
    'yt.scheduleShare.reload': 'Tải lại',
    'yt.scheduleShare.searchPlaceholder': 'Tìm theo tên page...',
    'yt.scheduleShare.loadPagesFailed': 'Không tải được pages.',
    'yt.scheduleShare.noPages': 'Tài khoản này chưa quản lý page nào.',
    'yt.scheduleShare.noMatch': 'Không tìm thấy page khớp "{query}".',
    'yt.scheduleShare.deselect': 'Bỏ chọn',
    'yt.scheduleShare.selectVisible': 'Chọn {count} page hiển thị',
    'yt.scheduleShare.selectAll': 'Chọn tất cả {count} page',
    'yt.scheduleShare.section2': 'Nội dung chung',
    'yt.scheduleShare.pickTemplate': 'Chọn mẫu...',
    'yt.scheduleShare.reset': 'Đặt lại',
    'yt.scheduleShare.captionPlaceholder': 'Hỗ trợ token {{title}} và {{link}}',
    'yt.scheduleShare.tokenHintPre': 'Token:',
    'yt.scheduleShare.tokenHintPost': '· Tối ưu ≤ {limit} ký tự',
    'yt.scheduleShare.charCount': '{count} ký tự',
    'yt.scheduleShare.previewWith': 'Preview với "{title}..."',
    'yt.scheduleShare.previewEmpty': '(rỗng)',
    'yt.scheduleShare.section3': 'Phân bổ thời gian',
    'yt.scheduleShare.strategy.spread': '🛡 Rải đều trong khoảng (khuyên dùng)',
    'yt.scheduleShare.strategy.spreadDesc': 'Chia đều N video trong window — tránh spam pattern',
    'yt.scheduleShare.strategy.rolling': '⏱ Cách đều cố định',
    'yt.scheduleShare.strategy.atOnce': '🔥 Cùng một lúc',
    'yt.scheduleShare.postAt': 'Đăng lúc',
    'yt.scheduleShare.firstPostAt': 'Video đầu tiên đăng lúc',
    'yt.scheduleShare.everyMinutes': 'Mỗi (phút)',
    'yt.scheduleShare.spreadWithin': 'Rải trong khoảng',
    'yt.scheduleShare.otherHours': 'Khác (h)',
    'yt.scheduleShare.betweenPosts': '≈ {minutes} phút giữa mỗi bài',
    'yt.scheduleShare.antiSpam.title': '🛡 Tránh bị đánh spam',
    'yt.scheduleShare.antiSpam.jitter': 'Thêm jitter ngẫu nhiên ±15% — break bot pattern',
    'yt.scheduleShare.antiSpam.avoidNight': 'Tránh giờ đêm (0h-8h) — shift sang 8h sáng',
    'yt.scheduleShare.lastPostAtPre': 'Video cuối đăng lúc',
    'yt.scheduleShare.section4': 'Danh sách bài đăng ({count})',
    'yt.scheduleShare.totalPostsPre': 'Tổng',
    'yt.scheduleShare.totalPostsPost': 'bài đăng sẽ được tạo',
    'yt.scheduleShare.cancel': 'Hủy',
    'yt.scheduleShare.submit': 'Lên lịch {videos} × {pages} page',
    'yt.scheduleShare.toast.pickAccount': 'Vui lòng chọn tài khoản Facebook.',
    'yt.scheduleShare.toast.pickPage': 'Chọn ít nhất 1 page.',
    'yt.scheduleShare.toast.noValidVideo': 'Không có video nào hợp lệ.',
    'yt.scheduleShare.toast.future': 'Thời gian phải ở tương lai.',
    'yt.scheduleShare.toast.scheduledSkipped':
      'Đã lên lịch {total} bài. Bỏ qua {skipped} (đã share hoặc đã có lịch).',
    'yt.scheduleShare.toast.scheduled': 'Đã lên lịch {total} bài đăng.',
    'yt.scheduleShare.toast.allSkipped':
      'Tất cả {skipped} cặp (video × page) đã share hoặc đã có lịch.',
    'yt.scheduleShare.toast.allAlready':
      'Tất cả video đã share hoặc đã có lịch tới các page được chọn.',
    'yt.scheduleShare.toast.failed': 'Lên lịch thất bại.',

    // ===== ShareToFacebookDrawer =====
    'yt.shareToFacebook.title': 'Chia sẻ video lên Facebook Page',
    'yt.shareToFacebook.section1': 'Chọn nơi chia sẻ',
    'yt.shareToFacebook.accountLabel': 'Tài khoản Facebook',
    'yt.shareToFacebook.noAccountPre': 'Chưa có tài khoản Facebook. Liên kết tại',
    'yt.shareToFacebook.noAccountPost': '.',
    'yt.shareToFacebook.inactiveSuffix': ' (chưa kích hoạt)',
    'yt.shareToFacebook.pagesLabel': 'Page nhận chia sẻ',
    'yt.shareToFacebook.reloadTooltip': 'Tải lại danh sách page',
    'yt.shareToFacebook.reload': 'Tải lại',
    'yt.shareToFacebook.searchPlaceholder': 'Tìm theo tên page...',
    'yt.shareToFacebook.loadPagesFailed': 'Không tải được pages. Token FB có thể đã hết hạn.',
    'yt.shareToFacebook.noPages': 'Tài khoản này chưa quản lý page nào.',
    'yt.shareToFacebook.noMatch': 'Không tìm thấy page khớp "{query}".',
    'yt.shareToFacebook.deselect': 'Bỏ chọn',
    'yt.shareToFacebook.selectVisible': 'Chọn {count} page hiển thị',
    'yt.shareToFacebook.selectAll': 'Chọn tất cả {count} page',
    'yt.shareToFacebook.section2': 'Soạn nội dung',
    'yt.shareToFacebook.pickCaption': 'Chọn mẫu caption...',
    'yt.shareToFacebook.reset': 'Đặt lại',
    'yt.shareToFacebook.contentPlaceholder': 'Nhập nội dung post...',
    'yt.shareToFacebook.optimalChars': '💡 Tối ưu Facebook: ≤ {limit} ký tự',
    'yt.shareToFacebook.charCount': '{count} ký tự',
    'yt.shareToFacebook.section3': 'Thời gian đăng',
    'yt.shareToFacebook.mode.now': 'Đăng ngay',
    'yt.shareToFacebook.mode.schedule': 'Lên lịch',
    'yt.shareToFacebook.postAt': 'Đăng lúc',
    'yt.shareToFacebook.preview': 'Xem trước',
    'yt.shareToFacebook.previewEmpty': 'Chọn ít nhất 1 page để xem preview.',
    'yt.shareToFacebook.cancel': 'Hủy',
    'yt.shareToFacebook.submit.schedule': 'Lên lịch tới {count} page',
    'yt.shareToFacebook.submit.shareMany': 'Chia sẻ tới {count} page',
    'yt.shareToFacebook.submit.share': 'Chia sẻ',
    'yt.shareToFacebook.toast.pickAccount': 'Vui lòng chọn tài khoản Facebook.',
    'yt.shareToFacebook.toast.pickPage': 'Chọn ít nhất 1 page.',
    'yt.shareToFacebook.toast.missingLink': 'Thiếu link video.',
    'yt.shareToFacebook.toast.invalidTime': 'Thời gian không hợp lệ.',
    'yt.shareToFacebook.toast.future': 'Thời gian phải ở tương lai.',
    'yt.shareToFacebook.toast.scheduledSkipped':
      'Đã lên lịch lúc {time}. Bỏ qua {skipped} page đã share/đã lên lịch trước đó.',
    'yt.shareToFacebook.toast.scheduled': 'Đã lên lịch chia sẻ lúc {time}.',
    'yt.shareToFacebook.toast.allSkippedNoNew':
      'Tất cả {skipped} page đã share hoặc đã có lịch — không tạo lịch mới.',
    'yt.shareToFacebook.toast.allSkipped': 'Tất cả {skipped} page đã share hoặc đã có lịch.',
    'yt.shareToFacebook.toast.videoAllAlready':
      'Video này đã share hoặc đã có lịch tới tất cả page được chọn.',
    'yt.shareToFacebook.toast.scheduleFailed': 'Lên lịch thất bại.',
    'yt.shareToFacebook.toast.skippedNote': ' Bỏ qua {skipped} page đã share.',
    'yt.shareToFacebook.toast.sharedSuccess': 'Đã chia sẻ tới {success} page.{note}',
    'yt.shareToFacebook.toast.sharedPartial':
      'Thành công {success} / {total}. Có {failed} thất bại.{note}',
    'yt.shareToFacebook.toast.allShared':
      'Tất cả {skipped} page đã share video này — không có gì để chia sẻ.',
    'yt.shareToFacebook.toast.sharedAllFailed': 'Chia sẻ thất bại cho tất cả {total} page.',
    'yt.shareToFacebook.toast.shareFailed': 'Chia sẻ thất bại.',

    // ===== ShareToXDrawer =====
    'yt.shareToX.title': 'Đăng video lên X (Twitter)',
    'yt.shareToX.section1': 'Chọn tài khoản X',
    'yt.shareToX.accountLabel': 'Tài khoản X (Twitter)',
    'yt.shareToX.searchPlaceholder': 'Tìm theo @handle hoặc tên...',
    'yt.shareToX.noAccountPre': 'Chưa có tài khoản X nào đang active. Liên kết tại',
    'yt.shareToX.noAccountPost': '.',
    'yt.shareToX.noMatch': 'Không tìm thấy tài khoản khớp "{query}".',
    'yt.shareToX.deselect': 'Bỏ chọn',
    'yt.shareToX.selectVisible': 'Chọn {count} tài khoản hiển thị',
    'yt.shareToX.selectAll': 'Chọn tất cả {count} tài khoản',
    'yt.shareToX.usage.tooltipBlocked':
      'Đã chạm giới hạn {used}/{limit} tweet/24h ({tier}). Reset {reset}.',
    'yt.shareToX.usage.tooltipOk': 'Đã đăng {used}/{limit} tweet trong 24h gần nhất ({tier} tier).',
    'yt.shareToX.usage.tooltipResetSuffix': ' Window reset {reset}.',
    'yt.shareToX.warn.atLimitPre': 'đã chạm giới hạn',
    'yt.shareToX.warn.atLimitPost': 'tweet/24h. Đăng thêm có thể bị X từ chối. Reset {reset}.',
    'yt.shareToX.warn.nearLimitPre': 'sắp chạm limit:',
    'yt.shareToX.warn.nearLimitMid': 'tweet/24h. Còn',
    'yt.shareToX.warn.nearLimitPost': 'tweet trước khi bị chặn.',
    'yt.shareToX.warn.quotaInfo':
      'ℹ️ {count} tài khoản đã dùng > 70% quota hôm nay — cân nhắc để dành quota cho post quan trọng.',
    'yt.shareToX.section2': 'Soạn tweet',
    'yt.shareToX.pickTemplate': 'Chọn mẫu...',
    'yt.shareToX.reset': 'Đặt lại',
    'yt.shareToX.tweetPlaceholder': 'Nhập nội dung tweet...',
    'yt.shareToX.limitPre': 'Giới hạn X:',
    'yt.shareToX.limitPost': 'ký tự',
    'yt.shareToX.urlTooltip': 'X tự rút gọn URL về t.co ({weight} ký tự)',
    'yt.shareToX.urlCount': '{count} link × {weight} ký tự',
    'yt.shareToX.overLimitNote': 'Vượt {over} ký tự — chưa thể đăng.',
    'yt.shareToX.truncateTooltip': 'Tự cắt phần text dư, giữ lại link',
    'yt.shareToX.truncate': 'Cắt vừa {limit}',
    'yt.shareToX.tipLabel': 'Tip X:',
    'yt.shareToX.tipBody':
      'URL được X rút gọn tự động về t.co ({weight} ký tự), thumbnail YouTube hiển thị thành link card. Dùng 1-2 hashtag là hiệu quả nhất, đừng spam.',
    'yt.shareToX.preview': 'Xem trước trên X',
    'yt.shareToX.previewEmpty': 'Chọn ít nhất 1 tài khoản X để xem preview.',
    'yt.shareToX.previewMultiPre':
      'Preview hiển thị tài khoản đầu tiên. Tweet sẽ đăng cùng lúc lên',
    'yt.shareToX.previewMultiPost': 'tài khoản.',
    'yt.shareToX.cancel': 'Hủy',
    'yt.shareToX.submit.empty': 'Nhập nội dung',
    'yt.shareToX.submit.over': 'Vượt {over} ký tự',
    'yt.shareToX.submit.allAtLimit': 'Tất cả đã chạm limit',
    'yt.shareToX.submit.postMany': 'Đăng lên {count} tài khoản',
    'yt.shareToX.submit.post': 'Đăng lên X',
    'yt.shareToX.toast.pickAccount': 'Chọn ít nhất 1 tài khoản X.',
    'yt.shareToX.toast.empty': 'Nội dung không được để trống.',
    'yt.shareToX.toast.overLimit': 'Vượt {over} ký tự. Bấm "Cắt vừa {limit}" để rút gọn.',
    'yt.shareToX.toast.missingLink': 'Thiếu link video.',
    'yt.shareToX.toast.skippedNote': ' Bỏ qua {skipped} đã share.',
    'yt.shareToX.toast.postedSuccess': 'Đã đăng lên {success} tài khoản X.{note}',
    'yt.shareToX.toast.postedPartial': 'Thành công {success}/{total}. Có {failed} thất bại.{note}',
    'yt.shareToX.toast.allShared': 'Tất cả {skipped} tài khoản đã share video này.',
    'yt.shareToX.toast.allFailed': 'Đăng thất bại cho tất cả {total} tài khoản.',
    'yt.shareToX.toast.postFailed': 'Đăng thất bại.',

    // ===== UploadVideoDrawer =====
    'yt.uploadVideo.privacy.private': 'Private — chỉ mình tôi xem',
    'yt.uploadVideo.privacy.unlisted': 'Unlisted — ai có link đều xem',
    'yt.uploadVideo.privacy.public': 'Public — công khai trên YouTube',
    'yt.uploadVideo.delay.now': 'Ngay',
    'yt.uploadVideo.delay.15m': '15 phút',
    'yt.uploadVideo.delay.30m': '30 phút',
    'yt.uploadVideo.delay.1h': '1 giờ',
    'yt.uploadVideo.title': 'Đăng video lên YouTube',
    'yt.uploadVideo.videoFile': 'File video',
    'yt.uploadVideo.selected': 'Đã chọn',
    'yt.uploadVideo.videoHelper': 'Tối đa {limit}. Định dạng MP4, MOV, AVI…',
    'yt.uploadVideo.thumbnail': 'Thumbnail (tuỳ chọn)',
    'yt.uploadVideo.thumbHelper': 'JPG/PNG, tối đa {limit}. Tỉ lệ 16:9 (1280×720).',
    'yt.uploadVideo.titleField': 'Tiêu đề',
    'yt.uploadVideo.titlePlaceholder': 'Tiêu đề video...',
    'yt.uploadVideo.descField': 'Mô tả',
    'yt.uploadVideo.descPlaceholder': 'Mô tả, link, hashtag...',
    'yt.uploadVideo.tags': 'Tags',
    'yt.uploadVideo.tagsPlaceholder': 'vd: tutorial, react, chakra-ui',
    'yt.uploadVideo.tagsHelper': 'Phân tách bằng dấu phẩy.',
    'yt.uploadVideo.category': 'Chuyên mục',
    'yt.uploadVideo.privacyLabel': 'Quyền riêng tư',
    'yt.uploadVideo.madeForKids': 'Video dành cho trẻ em (COPPA)',
    'yt.uploadVideo.autoShare.title': 'Tự động chia sẻ lên Facebook sau khi đăng',
    'yt.uploadVideo.autoShare.desc':
      'Lên lịch share video này tới Facebook Page ngay sau khi upload.',
    'yt.uploadVideo.autoShare.privacyWarnPre': '⚠️ Video đang để',
    'yt.uploadVideo.autoShare.privacyWarnMid': '. Facebook chỉ hiện đúng thẻ link khi video',
    'yt.uploadVideo.autoShare.privacyWarnPost':
      '. Nên đổi "Quyền riêng tư" sang Public, hoặc đặt độ trễ đủ lâu để kịp công khai video trước khi đăng.',
    'yt.uploadVideo.autoShare.captionLabel': 'Caption (token {{title}} · {{link}})',
    'yt.uploadVideo.autoShare.pickTemplate': 'Chọn mẫu...',
    'yt.uploadVideo.autoShare.delayLabel': 'Đăng sau (phút kể từ lúc upload xong)',
    'yt.uploadVideo.uploading': 'Đang upload lên server...',
    'yt.uploadVideo.pushingToYoutube': 'Server đang đẩy lên YouTube — vui lòng chờ...',
    'yt.uploadVideo.cancel': 'Hủy',
    'yt.uploadVideo.submit': 'Đăng video',
    'yt.uploadVideo.toast.mustBeVideo': 'File phải là video.',
    'yt.uploadVideo.toast.videoTooBig': 'Video vượt giới hạn {limit}.',
    'yt.uploadVideo.toast.thumbType': 'Thumbnail phải là JPG hoặc PNG.',
    'yt.uploadVideo.toast.thumbTooBig': 'Thumbnail vượt giới hạn {limit}.',
    'yt.uploadVideo.toast.missingAccount': 'Thiếu tài khoản YouTube.',
    'yt.uploadVideo.toast.pickVideo': 'Chọn file video.',
    'yt.uploadVideo.toast.enterTitle': 'Nhập tiêu đề video.',
    'yt.uploadVideo.toast.uploadedThumbWarn':
      'Đã đăng video, nhưng đặt thumbnail thất bại: {error}',
    'yt.uploadVideo.toast.uploadedThumbError': 'Đã đăng video. Thumbnail lỗi: {error}',
    'yt.uploadVideo.toast.uploadSuccess': 'Đăng video lên YouTube thành công.',
    'yt.uploadVideo.toast.autoShareScheduled': 'Đã lên lịch chia sẻ video vừa đăng lên Facebook.',
    'yt.uploadVideo.toast.autoShareError': 'Video đã đăng nhưng lên lịch share lỗi: {error}',
    'yt.uploadVideo.toast.failedWord': 'thất bại',
    'yt.uploadVideo.toast.uploadFailed': 'Đăng video thất bại.',
  },
  en: {
    // ===== shareHelpers — caption presets =====
    'yt.shareHelpers.preset.default': 'Default (title + link)',
    'yt.shareHelpers.preset.hashtag': 'With YouTube hashtags',
    'yt.shareHelpers.preset.oneLine': 'Short one-liner',
    'yt.shareHelpers.preset.emoji': 'Emoji highlight',
    'yt.shareHelpers.preset.cta': 'Call to action',

    // ===== xShareHelpers — caption presets + reset countdown =====
    'yt.xShareHelpers.preset.default': 'Default (title + link)',
    'yt.xShareHelpers.preset.hashtag': 'YouTube + Video hashtags',
    'yt.xShareHelpers.preset.watchNow': 'Watch now (EN)',
    'yt.xShareHelpers.preset.watchVn': 'Watch now (VN)',
    'yt.xShareHelpers.preset.cta': 'Short CTA',
    'yt.xShareHelpers.reset.resetting': 'resetting',
    'yt.xShareHelpers.reset.inMinutes': 'in {value} min',
    'yt.xShareHelpers.reset.inHours': 'in {value}h',
    'yt.xShareHelpers.reset.atTime': 'at {value}',

    // ===== FacebookTargetPicker =====
    'yt.facebookTargetPicker.accountLabel': 'Facebook account',
    'yt.facebookTargetPicker.noAccountPre': 'No Facebook account yet. Go to',
    'yt.facebookTargetPicker.noAccountPost': 'to connect.',
    'yt.facebookTargetPicker.selectAccountOption': '-- Select account --',
    'yt.facebookTargetPicker.pagesLabel': 'Pages to share to',
    'yt.facebookTargetPicker.reload': 'Reload',
    'yt.facebookTargetPicker.searchPlaceholder': 'Search by page name...',
    'yt.facebookTargetPicker.loadPagesFailed': 'Could not load pages.',
    'yt.facebookTargetPicker.noPages': 'This account manages no pages.',
    'yt.facebookTargetPicker.noMatch': 'No page matches "{query}".',
    'yt.facebookTargetPicker.deselect': 'Deselect',
    'yt.facebookTargetPicker.selectVisible': 'Select {count} visible pages',
    'yt.facebookTargetPicker.selectAll': 'Select all {count} pages',

    // ===== AutoShareRuleDrawer =====
    'yt.autoShareRule.delay.now': 'Now',
    'yt.autoShareRule.delay.15m': '15 min',
    'yt.autoShareRule.delay.30m': '30 min',
    'yt.autoShareRule.delay.1h': '1 hour',
    'yt.autoShareRule.relative.never': 'never scanned',
    'yt.autoShareRule.relative.justNow': 'just now',
    'yt.autoShareRule.relative.minutesAgo': '{value} min ago',
    'yt.autoShareRule.relative.hoursAgo': '{value}h ago',
    'yt.autoShareRule.relative.daysAgo': '{value}d ago',
    'yt.autoShareRule.sampleVideoTitle': 'Sample channel video',
    'yt.autoShareRule.title': 'Auto-share new videos',
    'yt.autoShareRule.intro.pre': 'The system scans the channel every ~20 min. When it detects a',
    'yt.autoShareRule.intro.bold': 'new public video',
    'yt.autoShareRule.intro.post':
      ', it schedules a share to Facebook (after the delay you set — you can still cancel on the "Scheduled" page). Private/unlisted videos are not auto-shared.',
    'yt.autoShareRule.section1': 'Active rules ({count})',
    'yt.autoShareRule.empty': 'No rules yet. Create one in the section below.',
    'yt.autoShareRule.badge.running': 'Running',
    'yt.autoShareRule.badge.paused': 'Paused',
    'yt.autoShareRule.pageCount': '{count} pages',
    'yt.autoShareRule.ruleStats':
      'Delay {delay}m · detected {detected} · scheduled {scheduled} · scanned {scanned}',
    'yt.autoShareRule.tooltip.pause': 'Pause',
    'yt.autoShareRule.tooltip.resume': 'Resume',
    'yt.autoShareRule.tooltip.scanNow': 'Scan now',
    'yt.autoShareRule.tooltip.edit': 'Edit',
    'yt.autoShareRule.tooltip.delete': 'Delete',
    'yt.autoShareRule.section2.edit': 'Edit rule',
    'yt.autoShareRule.section2.create': 'Create new rule',
    'yt.autoShareRule.cancelEdit': 'Cancel edit',
    'yt.autoShareRule.captionLabel': 'Caption (tokens {{title}} · {{link}})',
    'yt.autoShareRule.pickTemplate': 'Pick a template...',
    'yt.autoShareRule.reset': 'Reset',
    'yt.autoShareRule.optimalChars': 'Optimal ≤ {limit} characters',
    'yt.autoShareRule.charCount': '{count} characters',
    'yt.autoShareRule.preview': 'Preview',
    'yt.autoShareRule.previewEmpty': '(empty)',
    'yt.autoShareRule.delayLabel': 'Delay before posting (minutes after a video is detected)',
    'yt.autoShareRule.delayNote.pre': 'Only videos published',
    'yt.autoShareRule.delayNote.bold': 'from now on',
    'yt.autoShareRule.delayNote.post':
      ' are auto-shared — existing videos on the channel are unaffected.',
    'yt.autoShareRule.close': 'Close',
    'yt.autoShareRule.saveChanges': 'Save changes',
    'yt.autoShareRule.createRule': 'Create rule',
    'yt.autoShareRule.confirm.deleteTitle': 'Delete rule?',
    'yt.autoShareRule.confirm.deleteDesc':
      'New videos will no longer be auto-shared to {count} pages. Previously created schedules are unaffected.',
    'yt.autoShareRule.confirm.deleteConfirm': 'Delete',
    'yt.autoShareRule.toast.toggleFailed': 'Failed to change status.',
    'yt.autoShareRule.toast.scanError': 'Scan error: {error}',
    'yt.autoShareRule.toast.scanDone':
      'Scan done: detected {detected} new videos, scheduled {scheduled} posts.',
    'yt.autoShareRule.toast.scanNoNew': 'Scan done: no new videos.',
    'yt.autoShareRule.toast.scanFailed': 'Scan failed.',
    'yt.autoShareRule.toast.deleted': 'Rule deleted.',
    'yt.autoShareRule.toast.deleteFailed': 'Delete failed.',
    'yt.autoShareRule.toast.pickAccount': 'Please select a Facebook account.',
    'yt.autoShareRule.toast.pickPage': 'Select at least 1 page.',
    'yt.autoShareRule.toast.updated': 'Rule updated.',
    'yt.autoShareRule.toast.updateFailed': 'Update failed.',
    'yt.autoShareRule.toast.created': 'Rule created. New videos from now on will be auto-shared.',
    'yt.autoShareRule.toast.createFailed': 'Failed to create rule.',

    // ===== ScheduleShareDrawer =====
    'yt.scheduleShare.window.6h': '6 hours',
    'yt.scheduleShare.window.12h': '12 hours',
    'yt.scheduleShare.window.1d': '1 day',
    'yt.scheduleShare.window.3d': '3 days',
    'yt.scheduleShare.window.1w': '1 week',
    'yt.scheduleShare.title': 'Schedule sharing of {count} videos to Facebook',
    'yt.scheduleShare.section1': 'Share target',
    'yt.scheduleShare.accountLabel': 'Facebook account',
    'yt.scheduleShare.noAccountPre': 'No Facebook account yet. Go to',
    'yt.scheduleShare.noAccountPost': 'to connect.',
    'yt.scheduleShare.pagesLabel': 'Pages to share to',
    'yt.scheduleShare.reload': 'Reload',
    'yt.scheduleShare.searchPlaceholder': 'Search by page name...',
    'yt.scheduleShare.loadPagesFailed': 'Could not load pages.',
    'yt.scheduleShare.noPages': 'This account manages no pages.',
    'yt.scheduleShare.noMatch': 'No page matches "{query}".',
    'yt.scheduleShare.deselect': 'Deselect',
    'yt.scheduleShare.selectVisible': 'Select {count} visible pages',
    'yt.scheduleShare.selectAll': 'Select all {count} pages',
    'yt.scheduleShare.section2': 'Shared content',
    'yt.scheduleShare.pickTemplate': 'Pick a template...',
    'yt.scheduleShare.reset': 'Reset',
    'yt.scheduleShare.captionPlaceholder': 'Supports tokens {{title}} and {{link}}',
    'yt.scheduleShare.tokenHintPre': 'Tokens:',
    'yt.scheduleShare.tokenHintPost': '· Optimal ≤ {limit} characters',
    'yt.scheduleShare.charCount': '{count} characters',
    'yt.scheduleShare.previewWith': 'Preview with "{title}..."',
    'yt.scheduleShare.previewEmpty': '(empty)',
    'yt.scheduleShare.section3': 'Time distribution',
    'yt.scheduleShare.strategy.spread': '🛡 Spread evenly (recommended)',
    'yt.scheduleShare.strategy.spreadDesc':
      'Distribute N videos evenly across the window — avoids spam patterns',
    'yt.scheduleShare.strategy.rolling': '⏱ Fixed interval',
    'yt.scheduleShare.strategy.atOnce': '🔥 All at once',
    'yt.scheduleShare.postAt': 'Post at',
    'yt.scheduleShare.firstPostAt': 'First video posts at',
    'yt.scheduleShare.everyMinutes': 'Every (min)',
    'yt.scheduleShare.spreadWithin': 'Spread within',
    'yt.scheduleShare.otherHours': 'Other (h)',
    'yt.scheduleShare.betweenPosts': '≈ {minutes} min between each post',
    'yt.scheduleShare.antiSpam.title': '🛡 Avoid spam flags',
    'yt.scheduleShare.antiSpam.jitter': 'Add random jitter ±15% — breaks bot patterns',
    'yt.scheduleShare.antiSpam.avoidNight': 'Avoid night hours (0–8am) — shift to 8am',
    'yt.scheduleShare.lastPostAtPre': 'Last video posts at',
    'yt.scheduleShare.section4': 'Post list ({count})',
    'yt.scheduleShare.totalPostsPre': 'A total of',
    'yt.scheduleShare.totalPostsPost': 'posts will be created',
    'yt.scheduleShare.cancel': 'Cancel',
    'yt.scheduleShare.submit': 'Schedule {videos} × {pages} pages',
    'yt.scheduleShare.toast.pickAccount': 'Please select a Facebook account.',
    'yt.scheduleShare.toast.pickPage': 'Select at least 1 page.',
    'yt.scheduleShare.toast.noValidVideo': 'No valid videos.',
    'yt.scheduleShare.toast.future': 'Time must be in the future.',
    'yt.scheduleShare.toast.scheduledSkipped':
      'Scheduled {total} posts. Skipped {skipped} (already shared or scheduled).',
    'yt.scheduleShare.toast.scheduled': 'Scheduled {total} posts.',
    'yt.scheduleShare.toast.allSkipped':
      'All {skipped} video × page pairs are already shared or scheduled.',
    'yt.scheduleShare.toast.allAlready':
      'All videos are already shared or scheduled to the selected pages.',
    'yt.scheduleShare.toast.failed': 'Scheduling failed.',

    // ===== ShareToFacebookDrawer =====
    'yt.shareToFacebook.title': 'Share video to Facebook Page',
    'yt.shareToFacebook.section1': 'Choose where to share',
    'yt.shareToFacebook.accountLabel': 'Facebook account',
    'yt.shareToFacebook.noAccountPre': 'No Facebook account yet. Connect at',
    'yt.shareToFacebook.noAccountPost': '.',
    'yt.shareToFacebook.inactiveSuffix': ' (inactive)',
    'yt.shareToFacebook.pagesLabel': 'Pages to share to',
    'yt.shareToFacebook.reloadTooltip': 'Reload page list',
    'yt.shareToFacebook.reload': 'Reload',
    'yt.shareToFacebook.searchPlaceholder': 'Search by page name...',
    'yt.shareToFacebook.loadPagesFailed': 'Could not load pages. The FB token may have expired.',
    'yt.shareToFacebook.noPages': 'This account manages no pages.',
    'yt.shareToFacebook.noMatch': 'No page matches "{query}".',
    'yt.shareToFacebook.deselect': 'Deselect',
    'yt.shareToFacebook.selectVisible': 'Select {count} visible pages',
    'yt.shareToFacebook.selectAll': 'Select all {count} pages',
    'yt.shareToFacebook.section2': 'Compose content',
    'yt.shareToFacebook.pickCaption': 'Pick a caption template...',
    'yt.shareToFacebook.reset': 'Reset',
    'yt.shareToFacebook.contentPlaceholder': 'Enter post content...',
    'yt.shareToFacebook.optimalChars': '💡 Facebook optimal: ≤ {limit} characters',
    'yt.shareToFacebook.charCount': '{count} characters',
    'yt.shareToFacebook.section3': 'Posting time',
    'yt.shareToFacebook.mode.now': 'Post now',
    'yt.shareToFacebook.mode.schedule': 'Schedule',
    'yt.shareToFacebook.postAt': 'Post at',
    'yt.shareToFacebook.preview': 'Preview',
    'yt.shareToFacebook.previewEmpty': 'Select at least 1 page to preview.',
    'yt.shareToFacebook.cancel': 'Cancel',
    'yt.shareToFacebook.submit.schedule': 'Schedule to {count} pages',
    'yt.shareToFacebook.submit.shareMany': 'Share to {count} pages',
    'yt.shareToFacebook.submit.share': 'Share',
    'yt.shareToFacebook.toast.pickAccount': 'Please select a Facebook account.',
    'yt.shareToFacebook.toast.pickPage': 'Select at least 1 page.',
    'yt.shareToFacebook.toast.missingLink': 'Missing video link.',
    'yt.shareToFacebook.toast.invalidTime': 'Invalid time.',
    'yt.shareToFacebook.toast.future': 'Time must be in the future.',
    'yt.shareToFacebook.toast.scheduledSkipped':
      'Scheduled at {time}. Skipped {skipped} pages already shared/scheduled.',
    'yt.shareToFacebook.toast.scheduled': 'Scheduled to share at {time}.',
    'yt.shareToFacebook.toast.allSkippedNoNew':
      'All {skipped} pages are already shared or scheduled — no new schedule created.',
    'yt.shareToFacebook.toast.allSkipped': 'All {skipped} pages are already shared or scheduled.',
    'yt.shareToFacebook.toast.videoAllAlready':
      'This video is already shared or scheduled to all selected pages.',
    'yt.shareToFacebook.toast.scheduleFailed': 'Scheduling failed.',
    'yt.shareToFacebook.toast.skippedNote': ' Skipped {skipped} already-shared pages.',
    'yt.shareToFacebook.toast.sharedSuccess': 'Shared to {success} pages.{note}',
    'yt.shareToFacebook.toast.sharedPartial':
      'Succeeded {success} / {total}. {failed} failed.{note}',
    'yt.shareToFacebook.toast.allShared':
      'All {skipped} pages already shared this video — nothing to share.',
    'yt.shareToFacebook.toast.sharedAllFailed': 'Sharing failed for all {total} pages.',
    'yt.shareToFacebook.toast.shareFailed': 'Sharing failed.',

    // ===== ShareToXDrawer =====
    'yt.shareToX.title': 'Post video to X (Twitter)',
    'yt.shareToX.section1': 'Select X accounts',
    'yt.shareToX.accountLabel': 'X (Twitter) accounts',
    'yt.shareToX.searchPlaceholder': 'Search by @handle or name...',
    'yt.shareToX.noAccountPre': 'No active X account yet. Connect at',
    'yt.shareToX.noAccountPost': '.',
    'yt.shareToX.noMatch': 'No account matches "{query}".',
    'yt.shareToX.deselect': 'Deselect',
    'yt.shareToX.selectVisible': 'Select {count} visible accounts',
    'yt.shareToX.selectAll': 'Select all {count} accounts',
    'yt.shareToX.usage.tooltipBlocked':
      'Reached the limit {used}/{limit} tweets/24h ({tier}). Resets {reset}.',
    'yt.shareToX.usage.tooltipOk': 'Posted {used}/{limit} tweets in the last 24h ({tier} tier).',
    'yt.shareToX.usage.tooltipResetSuffix': ' Window resets {reset}.',
    'yt.shareToX.warn.atLimitPre': 'has reached the limit',
    'yt.shareToX.warn.atLimitPost':
      'tweets/24h. Further posts may be rejected by X. Resets {reset}.',
    'yt.shareToX.warn.nearLimitPre': 'is near the limit:',
    'yt.shareToX.warn.nearLimitMid': 'tweets/24h. Only',
    'yt.shareToX.warn.nearLimitPost': 'tweets left before being blocked.',
    'yt.shareToX.warn.quotaInfo':
      "ℹ️ {count} accounts have used > 70% of today's quota — consider saving quota for important posts.",
    'yt.shareToX.section2': 'Compose tweet',
    'yt.shareToX.pickTemplate': 'Pick a template...',
    'yt.shareToX.reset': 'Reset',
    'yt.shareToX.tweetPlaceholder': 'Enter tweet content...',
    'yt.shareToX.limitPre': 'X limit:',
    'yt.shareToX.limitPost': 'characters',
    'yt.shareToX.urlTooltip': 'X auto-shortens URLs to t.co ({weight} characters)',
    'yt.shareToX.urlCount': '{count} link × {weight} characters',
    'yt.shareToX.overLimitNote': 'Over by {over} characters — cannot post yet.',
    'yt.shareToX.truncateTooltip': 'Auto-trim excess text, keep the link',
    'yt.shareToX.truncate': 'Trim to {limit}',
    'yt.shareToX.tipLabel': 'X tip:',
    'yt.shareToX.tipBody':
      "X auto-shortens URLs to t.co ({weight} characters), and the YouTube thumbnail renders as a link card. Using 1-2 hashtags works best — don't spam.",
    'yt.shareToX.preview': 'Preview on X',
    'yt.shareToX.previewEmpty': 'Select at least 1 X account to preview.',
    'yt.shareToX.previewMultiPre':
      'Preview shows the first account. The tweet will post simultaneously to',
    'yt.shareToX.previewMultiPost': 'accounts.',
    'yt.shareToX.cancel': 'Cancel',
    'yt.shareToX.submit.empty': 'Enter content',
    'yt.shareToX.submit.over': 'Over by {over} characters',
    'yt.shareToX.submit.allAtLimit': 'All at limit',
    'yt.shareToX.submit.postMany': 'Post to {count} accounts',
    'yt.shareToX.submit.post': 'Post to X',
    'yt.shareToX.toast.pickAccount': 'Select at least 1 X account.',
    'yt.shareToX.toast.empty': 'Content cannot be empty.',
    'yt.shareToX.toast.overLimit': 'Over by {over} characters. Click "Trim to {limit}" to shorten.',
    'yt.shareToX.toast.missingLink': 'Missing video link.',
    'yt.shareToX.toast.skippedNote': ' Skipped {skipped} already shared.',
    'yt.shareToX.toast.postedSuccess': 'Posted to {success} X accounts.{note}',
    'yt.shareToX.toast.postedPartial': 'Succeeded {success}/{total}. {failed} failed.{note}',
    'yt.shareToX.toast.allShared': 'All {skipped} accounts already shared this video.',
    'yt.shareToX.toast.allFailed': 'Posting failed for all {total} accounts.',
    'yt.shareToX.toast.postFailed': 'Posting failed.',

    // ===== UploadVideoDrawer =====
    'yt.uploadVideo.privacy.private': 'Private — only me',
    'yt.uploadVideo.privacy.unlisted': 'Unlisted — anyone with the link',
    'yt.uploadVideo.privacy.public': 'Public — visible on YouTube',
    'yt.uploadVideo.delay.now': 'Now',
    'yt.uploadVideo.delay.15m': '15 min',
    'yt.uploadVideo.delay.30m': '30 min',
    'yt.uploadVideo.delay.1h': '1 hour',
    'yt.uploadVideo.title': 'Upload video to YouTube',
    'yt.uploadVideo.videoFile': 'Video file',
    'yt.uploadVideo.selected': 'Selected',
    'yt.uploadVideo.videoHelper': 'Up to {limit}. Formats MP4, MOV, AVI…',
    'yt.uploadVideo.thumbnail': 'Thumbnail (optional)',
    'yt.uploadVideo.thumbHelper': 'JPG/PNG, up to {limit}. 16:9 ratio (1280×720).',
    'yt.uploadVideo.titleField': 'Title',
    'yt.uploadVideo.titlePlaceholder': 'Video title...',
    'yt.uploadVideo.descField': 'Description',
    'yt.uploadVideo.descPlaceholder': 'Description, links, hashtags...',
    'yt.uploadVideo.tags': 'Tags',
    'yt.uploadVideo.tagsPlaceholder': 'e.g. tutorial, react, chakra-ui',
    'yt.uploadVideo.tagsHelper': 'Separate with commas.',
    'yt.uploadVideo.category': 'Category',
    'yt.uploadVideo.privacyLabel': 'Privacy',
    'yt.uploadVideo.madeForKids': 'Made for kids (COPPA)',
    'yt.uploadVideo.autoShare.title': 'Auto-share to Facebook after upload',
    'yt.uploadVideo.autoShare.desc':
      'Schedule sharing this video to a Facebook Page right after upload.',
    'yt.uploadVideo.autoShare.privacyWarnPre': '⚠️ Video is set to',
    'yt.uploadVideo.autoShare.privacyWarnMid':
      '. Facebook only shows the proper link card when the video is',
    'yt.uploadVideo.autoShare.privacyWarnPost':
      '. Switch "Privacy" to Public, or set a long enough delay to make the video public before posting.',
    'yt.uploadVideo.autoShare.captionLabel': 'Caption (tokens {{title}} · {{link}})',
    'yt.uploadVideo.autoShare.pickTemplate': 'Pick a template...',
    'yt.uploadVideo.autoShare.delayLabel': 'Post after (minutes from upload completion)',
    'yt.uploadVideo.uploading': 'Uploading to server...',
    'yt.uploadVideo.pushingToYoutube': 'Server is pushing to YouTube — please wait...',
    'yt.uploadVideo.cancel': 'Cancel',
    'yt.uploadVideo.submit': 'Upload video',
    'yt.uploadVideo.toast.mustBeVideo': 'File must be a video.',
    'yt.uploadVideo.toast.videoTooBig': 'Video exceeds the {limit} limit.',
    'yt.uploadVideo.toast.thumbType': 'Thumbnail must be JPG or PNG.',
    'yt.uploadVideo.toast.thumbTooBig': 'Thumbnail exceeds the {limit} limit.',
    'yt.uploadVideo.toast.missingAccount': 'Missing YouTube account.',
    'yt.uploadVideo.toast.pickVideo': 'Choose a video file.',
    'yt.uploadVideo.toast.enterTitle': 'Enter a video title.',
    'yt.uploadVideo.toast.uploadedThumbWarn':
      'Video uploaded, but setting the thumbnail failed: {error}',
    'yt.uploadVideo.toast.uploadedThumbError': 'Video uploaded. Thumbnail error: {error}',
    'yt.uploadVideo.toast.uploadSuccess': 'Video uploaded to YouTube successfully.',
    'yt.uploadVideo.toast.autoShareScheduled': 'Scheduled sharing the uploaded video to Facebook.',
    'yt.uploadVideo.toast.autoShareError':
      'Video uploaded but scheduling the share failed: {error}',
    'yt.uploadVideo.toast.failedWord': 'failed',
    'yt.uploadVideo.toast.uploadFailed': 'Video upload failed.',
  },
};

export default fragment;
